import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=2a92933f&"
import script from "./TableView.vue?vue&type=script&lang=ts&"
export * from "./TableView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports